module.exports = "https://portperrypedals.ca/_res/img/oakridgeshospice.b9b883e.jpg";